import { PropsWithChildren } from 'react';
import { cx } from '@emotion/css';
import { DSHeading } from '@stihl-design-system/components';

import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';
import { DynamicLinkWrapper, LinkWrapperProps } from '@phoenix/team-m/dashboard/frontend/shared/dynamic-link-wrapper';

interface CustomerSupportCardProps extends LinkWrapperProps {
  title: string;
  icon: string;
  imageSrc: string;
}

export const CustomerSupportCard = ({
  title,
  icon,
  imageSrc,
  children,
  className,
  ...linkProps
}: PropsWithChildren<CustomerSupportCardProps>) => {
  return (
    <DynamicLinkWrapper
      aria-label={title}
      className={cx('relative flex flex-1 flex-col overflow-hidden rounded-lg bg-secondary-deep text-primary-white', className)}
      {...linkProps}
    >
      <div className={cx('relative h-56 w-full', { 'desktop:max-w-80 desktop:flex-1': !!className?.includes('desktop:flex-row') })}>
        <PhoenixImage src={imageSrc} layout="fill" objectFit="cover" sizes="(max-width: 767px) 100vw, (max-width: 1024px) 50vw" />
      </div>
      <div className="relative flex flex-1 flex-col gap-8 p-6 pt-7 stihl-text-body-default-reg">
        {linkProps.hyperLink && (
          <PhoenixIcon
            className="absolute right-8 top-8 h-4 w-4 text-primary-white"
            icon={getDesignSystemIcon('icon-external-link-16.svg')}
          />
        )}
        <div className="flex items-center gap-2">
          <PhoenixIcon className="h-4 w-4 text-primary-white" icon={getDesignSystemIcon(icon)} />
          <DSHeading tag="h3" theme="dark">
            {title}
          </DSHeading>
        </div>
        <div>{children}</div>
      </div>
    </DynamicLinkWrapper>
  );
};
